module.exports = __webpack_public_path__ + "static/media/view5.205d6244.jpg";